import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Hidden from "@mui/material/Hidden";
import Drawer from "@mui/material/Drawer";
import Menu from "@mui/icons-material/Menu";
import styles from "../../assets/jss/material-kit-react/components/headerStyle.js";
import logo192x192_blue from '../../assets/img/logo192x192.png';
import GridContainer from "../../components/Grid/GridContainer.js";
import GridItem from "../../components/Grid/GridItem.js";
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import PinterestIcon from '@mui/icons-material/Pinterest';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { language } from "../../config";
import Box from '@mui/material/Box';


const useStyles = makeStyles(styles);

export default function Header(props) {
  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [secondLogo, setSecondLogo] = React.useState(false);
  const settings = useSelector(state => state.settingsdata.settings);
  React.useEffect(() => {

    if (props.changeColorOnScroll) {
      window.addEventListener("scroll", headerColorChange);
    }
    return function cleanup() {
      if (props.changeColorOnScroll) {
        window.removeEventListener("scroll", headerColorChange);
      }
    };
  });

  const trigger = useScrollTrigger();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const headerColorChange = () => {
    const { color, changeColorOnScroll } = props;
    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > changeColorOnScroll.height) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[changeColorOnScroll.color]);
      setSecondLogo(true);
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[changeColorOnScroll.color]);
      setSecondLogo(false);
    }
  };
  const { color, rightLinks, leftLinks, fixed, absolute } = props;
  const appBarClasses = classNames({
    [classes.appBar]: true,
    [classes[color]]: color,
    [classes.absolute]: absolute,
    [classes.fixed]: fixed
  });
  const brandComponent = <Button
    href="/"
    className={classes.title}>
    {secondLogo ? <img src={logo192x192_blue} alt="Logo" /> :
      <img src={logo192x192_blue} alt="Logo" />
    }
  </Button>;
  return (
    <div>
      <AppBar className={appBarClasses} style={{ height: 116, width: '100%', marginTop: trigger ? 0 : 30 }}>
        {!trigger ? (
          <AppBar>
            <GridContainer className={classes.topColor}>
              <GridItem xs={12} className={classes.topMargin}>
                <PhoneEnabledIcon fontSize="small" className={classes.iconColor1} />
                <div className={classes.number}>+91 1234567890</div>
                {settings && settings.TwitterHandle ?
                  <Tooltip
                    id="instagram-twitter"
                    title={language.follow_twitter}
                    placement={window.innerWidth > 959 ? "top" : "left"}
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <Button
                      href={settings.TwitterHandle}
                      target="_blank"
                      color="primary"
                      className={classes.navLink}
                    >
                      <TwitterIcon fontSize="small" className={classes.iconColor} />
                    </Button>
                  </Tooltip>
                  : null}
                <LinkedInIcon fontSize="small" className={classes.iconColor} />

                {settings && settings.FacebookHandle ?
                  <Tooltip
                    id="instagram-facebook"
                    title={language.follow_facebook}
                    placement={window.innerWidth > 959 ? "top" : "left"}
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <Button
                      color="primary"
                      href={settings.FacebookHandle}
                      target="_blank"
                      className={classes.navLink}
                    >
                      <FacebookIcon fontSize="small" className={classes.iconColor} />
                    </Button>
                  </Tooltip>
                  : null}
                <PinterestIcon fontSize="small" className={classes.iconColor} />
              </GridItem>
            </GridContainer>
          </AppBar>
        ) : null}
        <Toolbar className={classes.container}>
          {leftLinks !== undefined ? brandComponent : null}
          <div className={classes.flex}>
            {leftLinks !== undefined ? (
              <Hidden smDown implementation="css">
                {leftLinks}
              </Hidden>
            ) : (
              brandComponent
            )}
          </div>
          <Box
            sx={{
              display: {
                xs: 'none',  // hidden on extra-small
                sm: 'none',  // hidden on small
                md: 'block'  // visible on medium and up
              }
            }}
          >
            {rightLinks}
          </Box>
          <Hidden mdUp>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerToggle}
            >
              <Menu />
            </IconButton>
          </Hidden>
        </Toolbar>
        <Hidden mdUp implementation="js">
          <Drawer
            variant="temporary"
            anchor={"right"}
            open={mobileOpen}
            classes={{
              paper: classes.drawerPaper
            }}
            onClose={handleDrawerToggle}
          >
            <div className={classes.appResponsive}>
              {leftLinks}
              {rightLinks}
            </div>
          </Drawer>
        </Hidden>
      </AppBar>
    </div>
  );
}

Header.defaultProp = {
  color: "white"
};

Header.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark"
  ]),
  rightLinks: PropTypes.node,
  leftLinks: PropTypes.node,
  brand: PropTypes.string,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark"
    ]).isRequired
  })
};